module.exports = __webpack_public_path__ + "static/media/boosting-grey.06d40ccc.svg";